import type { AgentToolStage } from "../../../hooks/agent-stream";

/**
 * Unknown/new approval-required tools must still render confirmation controls.
 * Shared by the web and native fallback cards so the two surfaces cannot drift.
 */
export function hasFallbackApproval(
  stage: AgentToolStage,
  approvalId?: string,
): approvalId is string {
  return stage === "pending_approval" && Boolean(approvalId);
}
